// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  index(context, params) {
    const { sortBy, descending, page, itemsPerPage } = params.pagination
      ? params.pagination
      : [null, null, null, null];
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.get("iron-type", {
        page: page,
        sortBy: sortBy,
        descending: descending,
        rowsPerPage: itemsPerPage,
        search: params.search
      })
        .then(({ data }) => {
          context.commit("set_iron_types", data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
          context.commit("set_error", response.data.errors);
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  },
  list(context) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.get("iron-type")
        .then(({ data }) => {
          context.commit("set_iron_types", data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
          context.commit("set_error", response.data.errors);
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  },
  add(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.post("iron-type", params.model)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
          context.commit("set_error", response.data.errors);
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  },
  update(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.put("iron-type/" + params.model.type, params.model)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
          context.commit("set_error", response.data.errors);
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  },
  delete(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.delete("iron-type/" + params.model.type)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
          context.commit("set_error", response.data.errors);
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  }
};
